import React, { useState } from 'react';
import { Box, Button, TextField, Typography, Paper, Grid } from '@mui/material';
import { API_BASE_URL } from '../../config';

const DEFAULT_FINANCE_NAME = 'SHREE SIDDHARAMESHWAR FINANCE AND LEASING';

const SheetPage = () => {
  const [financeName] = useState(DEFAULT_FINANCE_NAME);
  const [collectorName, setCollectorName] = useState('');
  const [date, setDate] = useState(() => new Date().toISOString().split('T')[0]);
  const [error, setError] = useState('');

  const handleDownload = (type) => {
    setError('');

    const finalFinanceName = financeName?.trim() || DEFAULT_FINANCE_NAME;

    const url = new URL(
      `${API_BASE_URL}/${type === 'tbd' ? 'tbd-sheet-pdf' : 'pigmy-sheet-pdf'}`
    );

    url.searchParams.append('financeName', finalFinanceName);
    if (collectorName && collectorName.trim()) {
      url.searchParams.append('collectorName', collectorName.trim());
    }
    url.searchParams.append('date', date);

    window.location.assign(url.toString());
  };

  return (
    <Box sx={{ padding: 3 }}>
      <Typography variant="h5" gutterBottom>
        Collection Sheets
      </Typography>

      <Paper elevation={3} sx={{ padding: 3, maxWidth: 700 }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              label="Finance Name"
              fullWidth
              value={financeName}
              InputProps={{ readOnly: true }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Collector Name"
              fullWidth
              value={collectorName}
              onChange={(e) => setCollectorName(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Date"
              type="date"
              fullWidth
              InputLabelProps={{ shrink: true }}
              value={date}
              onChange={(e) => setDate(e.target.value)}
            />
          </Grid>

          {error && (
            <Grid item xs={12}>
              <Typography color="error" variant="body2">
                {error}
              </Typography>
            </Grid>
          )}

          <Grid item xs={12} sm={6}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={() => handleDownload('tbd')}
            >
              TBD Sheet
            </Button>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Button
              variant="contained"
              color="secondary"
              fullWidth
              onClick={() => handleDownload('pigmy')}
            >
              Pigmy Sheet
            </Button>
          </Grid>
        </Grid>
      </Paper>

      <Box sx={{ marginTop: 2 }}>
        <Typography variant="body2" color="textSecondary">
          The generated PDF will contain the Finance Name, Date, Collector Name, and a
          table with columns: Name, Daily Amount, and an empty Paid Amount column. All
          entries are kept on a single page; if there are many accounts they are
          arranged side by side in multiple columns.
        </Typography>
      </Box>
    </Box>
  );
};

export default SheetPage;


